import React from 'react';
import { useNavigate } from 'react-router-dom';

const ProductNotFound = () => {
    const navigate = useNavigate();
    
    return (
        <div style={{ 
            display: 'flex', 
            flexDirection: 'column', 
            alignItems: 'center', 
            justifyContent: 'center', 
            textAlign: 'center', 
            minHeight: '80vh', 
            padding: '120px 2rem 4rem',
            backgroundColor: '#f4f7f5',
            fontFamily: "'Inter', sans-serif"
        }}>
            <div style={{ width: '100%', maxWidth: '30rem', marginBottom: '1.5rem', mixBlendMode: 'multiply' }}>
                <img 
                    src="https://cdn.dribbble.com/users/880004/screenshots/13812735/media/311ed52e37fc2a488e5d263b65f7c327.gif" 
                    alt="Empty Cart / Not Found" 
                    style={{ width: '100%', height: 'auto', borderRadius: '1rem' }} 
                />
            </div>
            <h2 style={{ fontSize: '2.5rem', fontWeight: 900, color: '#143d2c', marginBottom: '1rem', textTransform: 'uppercase', letterSpacing: '-0.5px' }}>
                Oops! Product Missing
            </h2>
            <p style={{ color: '#64748b', fontSize: '1.1rem', marginBottom: '2.5rem', maxWidth: '30rem', lineHeight: '1.6' }}>
                We couldn't find the product you're looking for. It might have been sold out, removed, or the link is broken. Let's get you back on track!
            </p>
            <button 
                onClick={() => navigate("/")} 
                style={{ 
                    backgroundColor: '#00b259', 
                    color: '#ffffff', 
                    fontWeight: 900, 
                    padding: '1.2rem 3rem', 
                    borderRadius: '1rem', 
                    boxShadow: '0 10px 15px -3px rgba(0, 178, 89, 0.3)', 
                    cursor: 'pointer', 
                    border: 'none', 
                    textTransform: 'uppercase', 
                    letterSpacing: '2px',
                    fontSize: '14px'
                }}
            >
                Continue Shopping
            </button>
        </div>
    );
};

export default ProductNotFound;
